import { render, staticRenderFns } from "./ypcxListConfig.vue?vue&type=template&id=09c5f883&scoped=true"
import script from "./ypcxListConfig.vue?vue&type=script&lang=js"
export * from "./ypcxListConfig.vue?vue&type=script&lang=js"
import style0 from "./ypcxListConfig.vue?vue&type=style&index=0&id=09c5f883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5f883",
  null
  
)

export default component.exports